export class Category {
  constructor (slug, name, namePlural, icon, bgcolor, isFront) {
    this.slug = slug
    this.name = name
    this.namePlural = namePlural
    this.icon = icon
    this.bgcolor = bgcolor
    this.isFront = isFront || false
  }

  toJSON () {
    return {
      slug: this.slug,
      name: this.name,
      namePlural: this.namePlural,
      icon: this.icon,
      isFront: this.isFront
    }
  }
}

export function getCategories () {
  const c = categories.map(s => s.toJSON())
  return c
}

export function getCategory (slug) {
  return categories.find(category => category.slug === slug)
}

const categories = [
  // front page
  new Category('dailysoaps', 'Daily Soaps', 'Daily Soaps', 'local_bar', true),
  new Category('serien', 'Serien', 'Serien', 'theaters', true),
  new Category('filme', 'Filme', 'Filme', 'movie', true),
  new Category('dokus', 'Dokus', 'Dokus', 'videocam', true),
  new Category('comedyshows', 'Comedy/Shows', 'Comedy Sendungen und Shows', 'cake', true),
  // SEO only
  new Category('dokusoaps', 'Dokusoaps', 'Dokusoaps', 'supervisor_account'),
  new Category('kindersendungen', 'Kindersendungen', 'Kindersendungen', 'child_care'),
  new Category('magazine', 'Magazine', 'Magazine', 'beach_access'),
  new Category('nachrichten', 'Nachrichten', 'Nachrichten-Sendungen', 'language'),
  new Category('sport', 'Sport', 'Sport-Sendungen', 'emoji_events'),
  new Category('talk', 'Talk', 'Talks-Shows', 'question_answer')
]
